import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { buildInvoiceOrBillLockedSuffix } from "@components/transactions/matchedInvoiceOrBillLock";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkCounterpartyCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkCounterpartyOptions = [],
        transactionsLockedByInvoiceOrBillCount = 0,
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set counterparty for ${pluralizeWithCount("transaction", selectedTransactionCount)}${buildInvoiceOrBillLockedSuffix(transactionsLockedByInvoiceOrBillCount)}`}
            options={transactionBulkCounterpartyOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
